import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const getSeriesData = (originalData) => {

    const nameCorrections = {
        "Asian": "Asian and Pacific Islander",
        "Multiple Races": "Two or More Races",
        "Native American": "American Indian",
    };

    // Rename keys in the data
    const data = Object.keys(originalData).reduce((acc, key) => {
        const correctedKey = nameCorrections[key] || key;
        acc[correctedKey] = originalData[key];
        return acc;
    }, {});

    // Desired order for sorting
    const desiredOrder = [
        "American Indian",
        "Hispanic",
        "Asian and Pacific Islander",
        "African American",
        "Two or More Races",
        "White",
    ];

    // Sort the races based on the desired order
    const races = Object.keys(data).sort((a, b) => {
        return desiredOrder.indexOf(a) - desiredOrder.indexOf(b);
    });

    const processedData = {
        'Not Graduated': [],
        'High School Graduate': [],
        '2-year': [],
        '4-year': []
    };

    const postSecondaryPercentages = {};
    const studentCounts = {};

    // Process the data
    races.forEach(race => {
        const raceData = data[race];
        raceData.forEach(item => {
            if (processedData[item.Education]) {
                processedData[item.Education].push(item.Value);
            }
            if (item.Education === "Post-secondary") {
                postSecondaryPercentages[race] = item.Value;
            }
            if (item.Education === "Number of Students") {
                studentCounts[race] = item.Value;
            }
        });
    });

    return { races, processedData, postSecondaryPercentages, studentCounts };
};

// const getSeriesData = (data) => {

//     const races = Object.keys(data);

//     const processedData = {
//         'Not Graduated': [],
//         'High School Graduate': [],
//         '2-year': [],
//         '4-year': []
//     };

//     const postSecondaryPercentages = {};
//     const studentCounts = {};

//     // Process the data
//     races.forEach(race => {
//         const raceData = data[race];
//         raceData.forEach(item => {
//             if (processedData[item.Education]) {
//                 processedData[item.Education].push(item.Value);
//             }
//             if (item.Education === "Post-secondary") {
//                 postSecondaryPercentages[race] = item.Value;
//             }
//             if (item.Education === "Number of Students") {
//                 studentCounts[race] = item.Value;
//             }
//         });
//     });

//     return {races, processedData, postSecondaryPercentages, studentCounts};
// };


class SubGroupStackedBarChart extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        // const { series, categories } = getSeriesData(this.props.programNames, this.props.completionData)
        const { races, processedData, postSecondaryPercentages, studentCounts } = getSeriesData(this.props.education_summary_data);

        const options = {
            chart: {
                type: 'bar',
                backgroundColor: null,
                height: 770,
                marginLeft: 270,
                marginRight: 50,
            },
            exporting: {
                enabled: false
            },
            colors: ['#DE3E40', '#FFB607', '#6AA4DC', '#9EE4F2'],
            title: {
                text: null,
                style: {
                    color: "#FFFFFF",
                },
            },
            xAxis: {
                categories: races,
                labels: {
                    style: {
                        color: "#fff",
						font: "normal normal normal 18px Arial",

                    }
                }
            },
            yAxis: {
                min: 0,
                max: 100, // Set the maximum to 100 for percentage
                title: {
                    text: "Percent (%)",
                    style: {
                        color: "#fff",
						font: "normal normal normal 18px Arial"
                    }
                },
                labels: {
                    style: {
                        color: "#fff",
						font: "normal normal normal 18px Arial"
                    }
                }
            },
            tooltip: {
                formatter: function() {
                    const race = this.x;
                    const seriesName = this.series.name;
                    const value = this.y;
                    const postSecondaryValue = postSecondaryPercentages[race];
                    const studentCountValue = studentCounts[race].toLocaleString(); // Format with comma
                    return `
                        <strong>${race}</strong><br/>
                        ${seriesName}: ${value.toFixed(1)}%<br/>
                        Post-secondary: ${postSecondaryValue.toFixed(1) }%<br/>
                        Number of Students: ${studentCountValue}`;
                }
            },
            legend: {
                align: 'center',
                verticalAlign: 'top',
                layout: 'horizontal',
                reversed: true,
                itemStyle: {
                    color: '#FFFFFF',
                    fontSize: '18px',
                    fontWeight: 'normal',
                    fontFamily: 'Arial',
                },
                symbolRadius: 0
            },
            plotOptions: {
                series: {
                    stacking: 'percent',
                    borderWidth: 0,
                    pointWidth: 40,
                    groupPadding: 0.1
                }
            },
            series: [
                {
                    name: '4-year',
                    data: processedData['4-year'],
                    color: '#9EE4F2'
                },
                {
                    name: '2-year',
                    data: processedData['2-year'],
                    color: '#6AA4DC'
                },
                {
                    name: 'High School Graduate',
                    data: processedData['High School Graduate'],
                    color: '#FFB607'
                },
                {
                    name: 'Not Graduated',
                    data: processedData['Not Graduated'],
                    color: '#DE3E40'
                }
            ]
        };

        return (
            <div>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
        );
    }
}


export default SubGroupStackedBarChart;